module.exports = __webpack_public_path__ + "img/icon-stock-type.1155758a.png";